import "./once/00-htmx.js";
import "./once/01-stacked-events.js";
import "./once/body.js";
import "./once/toast.js";
export default {};